import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const warrantyFields = [
  // {
  //   label: 'Phone',
  //   key: 'phone_uuid',
  //   type: 'auto_complete',
  //   options: { entity: 'phones', path: apiPaths.PHONES },

  // },
  { label: 'Brand', key: 'brand' },
  { label: 'Model', key: 'model' },
  {
    label: 'Customer',
    key: 'customer_uuid',
    type: 'auto_complete',
    options: { entity: 'customers', path: apiPaths.CUSTOMERS },
  },
  {
    label: 'Store',
    key: 'store_uuid',
    type: 'auto_complete',
    options: { entity: 'stores', path: apiPaths.STORES },
  },
  // {
  //   label: 'Service',
  //   key: 'service',
  //   type: 'select',
  //   items: [
  //     { value: 'theft', label: 'Theft' },
  //     { value: 'exchange_with_old', label: 'Exchange With Old' },
  //     { value: 'exchange_unrepairable', label: 'Exchange Unrepairable' },
  //     { value: 'exchange_thirty_days', label: 'Exchange Thirty Days' },
  //     { value: 'repaire', label: 'Repaire' },
  //   ],
  //   // show: { key: 'type', value: 'organisational' },
  // },
];
const WarrantyForm = () => {
  return (
    <CrudGridForm
      path={apiPaths.WARRANTIES + '/service'}
      name="Warranty"
      entityName={'warranties'}
      fields={warrantyFields}
    />
  );
};

export default WarrantyForm;
